import React from "react";
import AspectRatioContainer from "../../../services/Utils/AspectRatioContainer";
import * as AssetManagerTypes from "../AssetManager.types";
import IAsset from "../../../models/IAsset";
import { addLineBreaks, massageFileDescription } from "../AssetManagerUtils/utilities";
import { AbstractTooltip as Tooltip } from "../../ToolTip/ToolTip";
import { ReactComponent as PdfIcon } from "../../../assets/icons/AssetManager/type-file-pdf-icon-not-selected.svg";
import { ReactComponent as VideoIcon } from "../../../assets/icons/AssetManager/type-file-video-icon-not-selected.svg";
import { ReactComponent as InteractiveDiagramIcon } from "../../../assets/icons/AssetManager/interactive-diagram-icon.svg";
// import lodash from "lodash"

function AssetLibraryListView(props: AssetManagerTypes.AssetLibraryListViewProps) {
  if (props.data.length === 0) {
  }
  const totalImages = React.useRef(props.data.length);
  totalImages.current = props.data.length;
  const handleAssetClick = (asset: IAsset) => (e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
    (props.AssetManagerDispatch as AssetManagerTypes.Dispatch<IAsset>)({
      type: "SELECT_ASSET",
      payload: asset,
    });

  const isSelected = (el: any) => {
    return el.assetVersionId === props.selectedAsset.assetId;
  };
  const showAsArchived = props.hasCurrentLessonFilter;

  return (
    <div className="assetLibrary-list-view-two-column" style={{ display: props.assetsAreLoading ? "none" : "" }}>
      {props.data.length > 0 && (
        <div className="assetLibrary-list-view-header">
          <div>
            <p>File Name and description</p>
          </div>
        </div>
      )}
      {props.data.length > 0 ? (
        <div className="assetLibrary-list-view-content-two-columns">
          {props.data.map((el: any, index: number) => {
            const isArchived = showAsArchived && el.isArchived;
            const sizeMB = el.sizeInBytes / (1024 * 1024);
            const assetSizeLabel = sizeMB < 1 ? "< 1 MB" : sizeMB.toFixed() + " MB";
            const assetSizeLabelColor = {
              background: sizeMB > 200 ? "rgba(255,0,0,0.65)" : "rgba(0,0,0,0.65)",
            };
            return (
              <div
                key={"astmngrlistvw" + index}
                className={`assetLibrary-single-asset-container two-column ${isArchived ? "archived" : ""}`}
                onClick={handleAssetClick(el)}
                style={
                  isSelected(el)
                    ? {
                        background: "var(--cpat-green-hover)",
                        color: "white",
                        gridColumn: index < 6 ? 1 : 2,
                        gridRow: (index % 6) + 1,
                      }
                    : {
                        gridColumn: index < 6 ? 1 : 2,
                        gridRow: (index % 6) + 1,
                      }
                }
              >
                <div className="assetLibrary-list-view-content-name two-column">
                    <div className="assetLibrary-list-view-thumbnail-wrapper">
                      {props.typeMode === 4 && (
                          <AspectRatioContainer
                            height={100}
                            width={100}
                            src={el.blobPath}
                            additionalStyle={{ position: "absolute" }}
                            onLoadError={(e: any) => {}}
                          />
                      )}
                      {props.typeMode === 7 && (
                        <div className="assetLibrary-list-view-pdf-icon">
                            <PdfIcon />
                        </div>
                      )}
                      {props.typeMode === 8 && (
                        <div className="assetLibrary-list-view-video-icon">
                            <VideoIcon />
                        </div>
                      )}
                      {props.typeMode === 10 && (
                        <div className="assetLibrary-list-view-interactive-diagram-icon">
                            <InteractiveDiagramIcon />
                        </div>
                      )}
                        <div className="assetLibrary-list-view-image-size-label" style={assetSizeLabelColor}>
                            {assetSizeLabel}
                        </div>
                    </div>
                  <div
                    className={`assetLibrary-list-view-two-column-name-description ${
                      isSelected(el) ? "selected" : ""
                    } ${isArchived ? "archived" : ""}`}
                  >
                    <div className={`assetLibrary-list-view-two-column-info-container ${isArchived ? "archived" : ""}`}>
                      <div className="assetLibrary-list-view-two-column-info-name-description">
                        <p className="assetLibrary-list-view-two-column-name">{el.name}</p>
                        <p
                          className="assetLibrary-list-view-two-column-description"
                          data-tooltip-id="description-tooltip"
                        >
                          {el.description}
                        </p>
                        <Tooltip id={"description-tooltip"} />
                      </div>
                      {isArchived && (
                        <div>
                          <p className="is-archived-tag">Archived</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="assetLibrary-listView-no-results">Sorry, We found No results matching your filters</div>
      )}
    </div>
  );
}
export default AssetLibraryListView;
